// ==================== src/api/system/user.ts ====================
// 对应后端：system.auth.controller.UserController
// 请求前缀：/auth/login, /auth/register, /auth/info, /auth/users/page
import { post } from '@/utils/HttpUtils';
import type { PageResult } from '../common';
import type { BiliUserCard } from '../bilibili/user';
import type { PointsInfo } from './points';

// ---------- 认证 ----------
export interface LoginParams {
  userName: string;
  password: string;
}

export interface RegisterParams {
  userName: string;
  password: string;
}

// ---------- 用户信息 ----------
export interface UserInfo {
  userId: string;
  username: string;
  roles: string[];
  pointsInfo: PointsInfo;
  email?: string;
  biliInfos?: BiliUserCard[];
}

// ---------- 用户分页查询参数 ----------
export interface UserPageQuery {
  current: number;
  size: number;
  /** 角色名称精确筛选（如 ROLE_ADMIN），null 表示不限 */
  roleName?: string;
  /** 是否已绑定 B 站账号筛选，null 表示不限 */
  bound?: boolean;
  /** 模糊搜索关键词，匹配：用户ID、用户名、B站UID、B站昵称 */
  keyword?: string;
  /** 排序字段，默认 points，可选：userName、points */
  sortBy?: string;
  /** 排序方向：ASC 或 DESC，默认 ASC */
  sortDirection?: string;
}

export const systemUserApi = {
  // ---------- 认证 ----------
  login: (data: LoginParams) =>
    post<{ token: string; roles: string[] }>('/auth/login', data),

  register: (data: RegisterParams) =>
    post('/auth/register', data),

  // ---------- 用户信息 ----------
  getUserInfo: () =>
    post<UserInfo>('/auth/info'),

  getUserListPage: (query: UserPageQuery) =>
    post<PageResult<UserInfo>>('/auth/users/page', query),
};